import { put, takeLatest, call } from "redux-saga/effects";
import {
	setListStaff,
	setDetailStaff,
	GetListStaffAsyncPayload,
	getListStaffAsync,
	GetDetailStaffAsyncPayload,
	getDetailStaffAsync,
	CreateStaffAsyncPayload,
	createStaffAsync,
	UpdateStaffAsyncPayload,
	updateStaffAsync,
	ChangePassStaffAsyncPayload,
	changePassStaffAsync,
} from "./staff.slice";
import { message } from "antd";
import { setLoadingPage } from "store/app/app.slice";
import api from "service/apiService";
import { t } from "@lingui/macro";
import { translate } from "utils";
import { PayloadAction } from "@reduxjs/toolkit";
import { ApiResponse } from "types";
import { Staff } from "../types";
import { getMyProfileAsync } from "store/auth/authSlice";

// Get list
function* getListStaffSaga(action: PayloadAction<GetListStaffAsyncPayload>) {
	// yield put({ type: setLoadingPage.type, payload: true });
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		let { skip } = query;
		const { take } = query;
		skip = skip * take;
		try {
			const { data: response } = await api.get<ApiResponse<Staff[]>>("/staff", {
				...query,
				skip,
			});
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setListStaff.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
	callback && callback();
	// yield put({ type: setLoadingPage.type, payload: false });
}
function* watchGetListStaff() {
	yield takeLatest(getListStaffAsync, getListStaffSaga);
}

// Detail
function* getDetailStaffSaga(
	action: PayloadAction<GetDetailStaffAsyncPayload>,
) {
	const { id } = action.payload;
	// yield put({ type: setLoadingPage.type, payload: true });
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<Staff>>(
				`/staff/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setDetailStaff.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
	// yield put({ type: setLoadingPage.type, payload: false });
}
function* watchGetDetailStaff() {
	yield takeLatest(getDetailStaffAsync, getDetailStaffSaga);
}

// Create
function* createStaffSaga(action: PayloadAction<CreateStaffAsyncPayload>) {
	const { data, returnStatus } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.post("/staff", data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		// message.success(t`Create successful`);
		returnStatus(true);
	} else {
		message.error(translate(error.message));
		returnStatus(false);
	}
}
function* watchCreateStaff() {
	yield takeLatest(createStaffAsync, createStaffSaga);
}

// Update
function* updateStaffSaga(action: PayloadAction<UpdateStaffAsyncPayload>) {
	const { id, data, myProfileId, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.patch(`/staff/${id}`, data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(t`Update successful`);
		if (id === myProfileId)
			yield put({ type: getMyProfileAsync.type, payload: false });
	} else {
		message.error(translate(error.message));
	}

	callback && callback();
}
function* watchUpdateStaff() {
	yield takeLatest(updateStaffAsync, updateStaffSaga);
}

// Change password
function* changePassStaffSaga(
	action: PayloadAction<ChangePassStaffAsyncPayload>,
) {
	const { data, returnResult } = action.payload;
	yield put({ type: setLoadingPage.type, payload: true });
	const { response, error } = yield call(async () => {
		try {
			const response = await api.post("/staff/change-password", data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(t`Change password successful`);
		returnResult(true);
	} else {
		message.error(translate(error.message));
	}
	yield put({ type: setLoadingPage.type, payload: false });
}
function* watchChangePassStaff() {
	yield takeLatest(changePassStaffAsync, changePassStaffSaga);
}

const customerSaga = [
	watchGetListStaff(),
	watchGetDetailStaff(),
	watchCreateStaff(),
	watchUpdateStaff(),
	watchChangePassStaff(),
];
export default customerSaga;
